export default (store) => {
    store.subscribeAction({
        before: (action) => {
            if (action.type !== 'patch' || action.payload.scope.type !== 'project' 
                || Array.isArray(action.payload.attributes) && !action.payload.attributes.includes('address') || !action.payload.extension) {
                return
            }

            action.payload.scope.attributes.location = { ...action.payload.extension }
            action.payload.attributes.push('location')
        }
    })
}